<i18n src="./CategoriesMenu.txt" lang="yaml"></i18n>
<script src="./CategoriesMenu.js"></script>

<template>
  <nav>
    <ul v-if="categories && categories.length">
      <li
        class="position-stati"
        v-for="category in categories"
        :key="category.id"
        data-test="category-1st-level"
        @mouseenter="hoverOnCategory(category)"
        @mouseleave="hoverOffCategory()"
      >
      <div>
        <router-link
          :class="isActive(category.slug) ? 'active' : ''"
          :to="{
            name: 'products',
            params: { categorySlug: category.slug },
          }"
          data-test="category-1st-level-link"
        >
          {{ category.name.toUpperCase() }}
        </router-link>
      </div>
      <ul
        v-if="isMenuOpen(category)"
        class="dropdown-menu megamenu row dropdown-submenu"
      >
      <li class="">
        <div class="nav-accordion">
          <div
            v-for="category2ndLevel in category.children"
            :key="category2ndLevel.id"
          >
          <h3>
            <router-link
              :to="{ name: 'products', params: { categorySlug: category2ndLevel.slug } }"
              @click="clickOnCategory()"
              data-test="category-2nd-level-link"
            >
              {{ category2ndLevel.name }}
            </router-link>
          </h3>
        </div>
        </div>
      </li> 
      <!-- <li class="img-size">
              <img
                src="../../../assets/img/sunset-girl.jpg"
                class="img-responsive megamenu-img"
              />
      </li>    -->
      </ul>
      </li>
    </ul>
  </nav>

</template>

<style>
.megamenu.dropdown-menu {
  display: block !important;
}

.dropdown.menu-large.open .megamenu {
  padding: 20px;
}

.navbar-nav>li>.megamenu {
  width: 100%;
  border: solid 1px black;
  border-top: none;
  box-shadow: none;
}
.nav-accordion {
  list-style-type: none;
  text-transform: uppercase;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 0;
}

.img-size {
  display: inline-block;
  padding: 8px 0;
  font-size: 12px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
</style>
